import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [state, setState] = useState("idle");
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email)) {
      setState("error");
      setMessage("Please enter a valid email address.");
      return;
    }
    setState("sending");
    setMessage("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ formType: "newsletter", email, company }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok || body.ok !== true) throw new Error("failed");
      setState("success");
      setMessage("You're in — welcome to the community.");
      setEmail("");
    } catch {
      setState("error");
      setMessage("Something went wrong — please try again.");
    }
  };

  return (
    <section id="community" className="newsletter section-pad" data-testid="newsletter-section">
      <Reveal className="newsletter-inner">
        <p className="eyebrow" data-testid="newsletter-eyebrow">Stay connected</p>
        <h2 className="section-heading">Join the Mindful Athlete Community</h2>
        <p className="section-sub">
          Get mindset tools, recovery tips, event updates and new Mindful Athlete opportunities delivered to your inbox.
        </p>
        <form className="newsletter-form" noValidate onSubmit={submit} data-testid="newsletter-form">
          <label htmlFor="newsletter-email" data-testid="newsletter-email-label">Email address</label>
          <div className="newsletter-row">
            <input
              id="newsletter-email"
              type="email"
              required
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="newsletter-email-input"
            />
            <button type="submit" className="btn btn-primary" disabled={state === "sending"} data-testid="newsletter-submit-button">
              {state === "sending" ? "Sending..." : "Join"} <ArrowUpRight size={16} />
            </button>
          </div>
          <input
            type="text"
            name="company"
            className="hp-field"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            data-testid="newsletter-honeypot"
          />
          {message && (
            <p className={`form-status ${state === "error" ? "form-status-error" : "form-status-success"}`} role="status" data-testid="newsletter-status">
              {message}
            </p>
          )}
        </form>
      </Reveal>
    </section>
  );
};

export default Newsletter;
